<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<a class="pcalibre1 calibre2 pcalibre" id="my-cover-image"></a><img alt="image" class="calibre3" src="images/00001.jpeg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000.vue?403f1910